import React from 'react'
import { Result } from 'antd'
import { useTranslation } from 'lib/i18n'

import CtaButton from 'components/CtaButton/CtaButton'
import Link from 'components/Link/Link'

const Error404 = () => {
  const { t } = useTranslation()

  return (
    <Result
      status="404"
      title={t('404.title', 'Page not found')}
      subTitle={t(
        '404.subTitle',
        'Sorry, the page you visited does not exist.',
      )}
      extra={
        <Link href="/">
          <CtaButton>{t('404.goBack', 'Go back Home')}</CtaButton>
        </Link>
      }
    />
  )
}

export default Error404
